<template>
    <div>
        <p class="text-right">
            Última actualización:
            <strong>{{ formattedUpdatedAt }}</strong>
        </p>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { getFullFormatDate } from '@/utils/globalFunctions.js';

const props = defineProps({
    updatedAt: {
        type: [String, Date],
        default: null
    }
});

const formattedUpdatedAt = computed(() => {
    return props.updatedAt ? getFullFormatDate(new Date(props.updatedAt)) : 'sin actualizaciones';
});
</script>

<style scoped>
.text-right {
    text-align: right;
    font-size: 12px;
    font-weight: 500;
    margin-top: 5px;
}
</style>
